<template>
  <div>
    <breadcrumbs></breadcrumbs>

    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      区域详情
    </div>

    <div>共计人数：{{ arr }}</div>
    <div class="adc"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="ID" prop="saleId"> </el-table-column>

      <el-table-column label="姓名" prop="saleName"> </el-table-column>

      <el-table-column label="职位" prop="jobName"> </el-table-column>

      <el-table-column label="手机号" prop="phone"> </el-table-column>

      <el-table-column label="入职时间" prop="addtime"> </el-table-column>

      <el-table-column label="直推回收站数" prop="zhiNum"> </el-table-column>

      <el-table-column label="分配回收站数" prop="fenNum"> </el-table-column>

      <el-table-column label="绑定回收站总数" prop="allNum"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dict from "../sys/dict.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    dict,
    breadcrumbs,
  },

  data() {
    return {
      tableData: [],
      arr: "",
    };
  },

  created() {
    this.getCityDetail();
  },

  methods: {
    getCityDetail() {
      this.$api.activitymsg
        .getCityDetail({
          cityId: this.$route.query.id,
        })
        .then((e) => {
          this.tableData = e.data;
          this.arr = e.data.length;
        });
    },
  },
};
</script>

<style scoped>
.adc {
  height: 20px;
}
</style>
